import styled from "styled-components";

export const ComboBoxContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;

  .flex {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
`;

export const ComboBoxInput = styled.input`
  position: relative;
  z-index: 90;
  width: 100%;
  padding: 0.5rem 1rem;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  box-sizing: border-box;
`;

export const ComboBoxList = styled.ul`
  position: absolute;
  overflow: hidden;
  z-index: 91;
  width: 100%;
  top: 4rem;
  list-style: none;
  border-radius: 0.5rem;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
`;

export const ComboBoxListItem = styled.li`
  width: 100%;
  position: relative;
  padding: 0.75rem 1rem;
  cursor: pointer;
  z-index: 95;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &:hover {
    background-color: #ccc;
  }
  & :last-child {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: wrap;
  }
`;

export const ComboBoxBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 80;
`;
